import Styles from './ChallengeLevelOneInstructions.module.scss'
import { InstructionCard } from 'components/global/InstructionCard/InstructionCard';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';


export function ChallengeLevelOneInstructions(props) {
    const { challenge_id } = useParams();
    const { stream_id } = useParams();

    const navigate = useNavigate();

    const challengeLevelOneInstructions = props.t('Streams.ChallengeLevelOne.ChallengeLevelOneInstructions.instructions', { returnObjects: true })

    const handleStartClick = () => {
        const options = {
            method: "POST",
            url: `/api/user/streams/${stream_id}/challenges/${challenge_id}/start`,
            headers: {
                "accept": "application/json",
            },
        };
        axios
            .request(options)
            .then(function (response) {
                // console.log("data", response)
                navigate(`/streams/${stream_id}/challenges/${challenge_id}`);
            })
            .catch((err) => {
                let status = err.response.status;
                console.log("error", status);
                navigate('/oops');
            });
    }

    const handleBackClick = () => {
        navigate(`/streams/${stream_id}/challenges`);
    }

    return (
        <div id='CardContainer' className={Styles.CardContainer}>
            <InstructionCard
                instructions={challengeLevelOneInstructions}
                handleStartClick={handleStartClick}
                handleBackClick={handleBackClick}
            />
        </div>
    )
}